import { LicenceModel } from '@kimuno/api-sdk/lib/types/responses/Billing';

const getReplacementLicence = (licenceModels: { [key: number]: LicenceModel }, licenceId: number) => {
  const activeLicenceModels = Object.values(licenceModels);
  const newLicence = activeLicenceModels.find((licenceModel) => licenceModel.replacesLicence === licenceId);
  return newLicence;
};

export default getReplacementLicence;
